import { api, getApiKeyFromLocalStorage, getBaseURL } from './apiClient';

export const getModels = async () => {
  const apiKey = getApiKeyFromLocalStorage();
  if (!apiKey) {
    throw new Error('API key is missing');
  }

  const response = await fetch(`${getBaseURL()}/models`, {
    method: 'GET',
    headers: {
      'x-api-key': apiKey,
    }
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const getModelsHealth = async () => {
  try {
    const apiKey = getApiKeyFromLocalStorage();
    if (!apiKey) {
      throw new Error('API key is missing');
    }

    const response = await api.get('/models/health', {
      headers: { 'x-api-key': apiKey }
    });

    if (response.status !== 200) {
      console.error('Failed to retrieve models health');
      return false;
    }

    return response.data.data;
  } catch (error) {
    console.error('Models health error:', error);
    return false;
  }
};

export const getModelsWithHealth = async () => {
  try {
    const apiKey = getApiKeyFromLocalStorage();
    if (!apiKey) {
      throw new Error('API key is missing');
    }

    const [modelsResponse, modelsHealthResponse] = await Promise.all([
      fetch(`${getBaseURL()}/models`, {
        method: 'GET',
        headers: {
          'x-api-key': apiKey,
        }
      }),
      fetch(`${getBaseURL()}/models/health`, {
        method: 'GET',
        headers: {
          'x-api-key': apiKey,
        }
      }).catch(error => {
        console.warn('Models health endpoint not available:', error);
        return null;
      })
    ]);

    if (!modelsResponse.ok) {
      throw new Error(`Failed to fetch models: ${modelsResponse.status}`);
    }

    const modelsData = await modelsResponse.json();
    let modelsHealthData = null;

    if (modelsHealthResponse && modelsHealthResponse.ok) {
      try {
        const healthResponse = await modelsHealthResponse.json();
        modelsHealthData = healthResponse.data || healthResponse;
      } catch (error) {
        console.warn('Failed to parse models health response:', error);
        modelsHealthData = null;
      }
    }

    const models = modelsData.data || [];
    
    return models.map(model => {
      let isHealthy = true;
      
      if (modelsHealthData && Array.isArray(modelsHealthData)) {
        const healthModel = modelsHealthData.find(healthModel => 
          healthModel.model === model.key
        );
        isHealthy = healthModel ? healthModel.status === true : true;
      }
      
      return {
        ...model,
        isHealthy
      };
    });
  } catch (error) {
    console.error('Error fetching models with health:', error);
    
    try {
      const fallbackResponse = await fetch(`${getBaseURL()}/models`, {
        method: 'GET',
        headers: {
          'x-api-key': getApiKeyFromLocalStorage(),
        }
      });
      
      if (fallbackResponse.ok) {
        const fallbackData = await fallbackResponse.json();
        const models = fallbackData.data || [];
        return models.map(model => ({
          ...model,
          isHealthy: true
        }));
      }
    } catch (fallbackError) {
      console.error('Fallback model fetch also failed:', fallbackError);
    }
    
    throw error;
  }
};

